/**
 * Metro exposes bundled `.mp3` differently per platform (number, string URL, `{ default }`).
 * Used by stake + section-toggle SFX helpers.
 */

import { Image } from 'react-native';

export function resolveBundledMp3NativeSource(moduleUnknown: unknown): number | { uri: string } | null {
  if (typeof moduleUnknown === 'number') return moduleUnknown;
  if (typeof moduleUnknown === 'string' && moduleUnknown.length > 0) {
    return { uri: moduleUnknown };
  }
  if (
    moduleUnknown !== null &&
    typeof moduleUnknown === 'object' &&
    'default' in moduleUnknown
  ) {
    const d = (moduleUnknown as { default: unknown }).default;
    if (typeof d === 'number') return d;
    if (typeof d === 'string' && d.length > 0) return { uri: d };
  }
  return null;
}

/** Web: absolute URL to bundled MP3 (HTMLAudio / fetch). */
export function resolveBundledMp3UriForWeb(moduleUnknown: unknown): string | null {
  try {
    if (typeof moduleUnknown === 'string' && moduleUnknown.length > 0) {
      return moduleUnknown;
    }
    if (
      moduleUnknown !== null &&
      typeof moduleUnknown === 'object' &&
      'default' in moduleUnknown
    ) {
      const d = (moduleUnknown as { default: unknown }).default;
      if (typeof d === 'string' && d.length > 0) return d;
      if (typeof d === 'number') {
        if (typeof Image.resolveAssetSource !== 'function') return null;
        const resolved = Image.resolveAssetSource(d);
        return resolved?.uri ?? null;
      }
    }
    if (typeof moduleUnknown === 'number') {
      if (typeof Image.resolveAssetSource !== 'function') return null;
      const resolved = Image.resolveAssetSource(moduleUnknown);
      return resolved?.uri ?? null;
    }
  } catch {
    return null;
  }
  return null;
}
